import React, { Component } from "react";
import { Grid } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-regular-svg-icons";

import { ImageLetters } from "../";
import { TYRE_POSITION } from "../../../../util/tyre";
import { ConditionIcon } from "../../../../components/";
import { getItemName, QUESTION_RESULT_STATUS, round2, getInterventionPriceWithVAT } from "../../../../util/common";

import "./index.scss";

class NotFixedItems extends Component {
  renderRow = (item, id, description, price, images, customer_ok, status) => {
    const { hideStatusIcons } = this.props;

    return (
      <>
        <Grid.Row key={id} className="not-fixed-row">
          <Grid.Column width={hideStatusIcons ? 12 : 10}>{item.title && <span className="not-fixed-title">{getItemName(this.props.t, item)}</span>}</Grid.Column>

          <Grid.Column width={2}>
            <ImageLetters images={images} lettersMap={this.props.lettersMap} />
          </Grid.Column>
          <Grid.Column width={2}>{price}</Grid.Column>
          {!hideStatusIcons && (
            <>
              <Grid.Column width={1} textAlign="center">
                <ConditionIcon status={status} size="small" />
              </Grid.Column>
              <Grid.Column width={1}>{customer_ok && <ConditionIcon status={10} size="small" />}</Grid.Column>
            </>
          )}
        </Grid.Row>
        {description && (
          <Grid.Row className="description-row">
            <Grid.Column width={16}>{description}</Grid.Column>
          </Grid.Row>
        )}
      </>
    );
  };

  renderPrice = price => {
    const { include_vat, vat } = this.props.settings;

    if (!(price > 0.01)) return null;

    if (include_vat) price = price * (1 + vat / 100);

    return <span className="not-fixed-price">€ {round2(price).toFixed(2)}</span>;
  };

  renderInterventionPrice = intervention => {
    const { include_vat } = this.props.settings;

    if (!(intervention.price > 0.01)) return null;

    const price = include_vat ? getInterventionPriceWithVAT(intervention, this.props.settings) : intervention.price;

    return <span className="not-fixed-price">€ {round2(price).toFixed(2)}</span>;
  };

  renderInterventions = interventions => {
    if (!Array.isArray(interventions)) return null;

    const { appointment } = this.props.communication;
    const hasImages = Array.isArray(appointment.final_check_images);

    return interventions.map(i =>
      this.renderRow(
        i,
        i.id,
        i.description,
        this.renderInterventionPrice(i),
        hasImages && appointment.final_check_images.filter(img => img.intervention_index === i.intervention_index),
        i.customer_ok
      )
    );
  };

  renderNotFixedItems = notFixedItem => {
    if (!Array.isArray(notFixedItem)) return null;

    return notFixedItem
      .filter(nfi => nfi.question_status > -1)
      .map(nfi =>
        this.renderRow(
          nfi,
          nfi.question_result_id + "_" + nfi.tyre_position,
          nfi.mechanic_notes,
          this.renderPrice(nfi.price),
          nfi.images,
          nfi.customer_approved,
          nfi.question_status
        )
      );
  };

  render() {
    const { communication, settings, notFixedItems, hideStatusIcons, t } = this.props;
    let { appointment } = communication;
    let interventions = appointment.interventions.filter(i => !i.mechanic_fixed);

    if (interventions.length < 1 && notFixedItems.length < 1) return null;

    return (
      <Grid verticalAlign="middle" className="report-not-fixed-container component-container">
        <Grid.Row className="not-fixed-heading">
          <Grid.Column width={16}>
            <div className="not-fixed-heading-title-container">
              <FontAwesomeIcon icon={faTimesCircle} className="not-fixed-heading-icon" />
              <h4 className="not-fixed-heading-title">{t("cc_items_not_fixed").message || "Items not fixed"}</h4>
            </div>
            {!hideStatusIcons && (
              <div className="not-fixed-heading-status-container">
                <div className="not-fixed-heading-status-item">
                  <ConditionIcon status={0} size="small" />
                  <span className="not-fixed-heading-status-text">{t("cc_all_right").message || "All right"}</span>
                </div>
                <div className="not-fixed-heading-status-item">
                  <ConditionIcon status={2} size="small" />
                  <span className="not-fixed-heading-status-text">{t("cc_advisable").message || "Advisable"}</span>
                </div>
                <div className="not-fixed-heading-status-item">
                  <ConditionIcon status={3} size="small" />
                  <span className="not-fixed-heading-status-text">{t("cc_necessary").message || "Necessary"}</span>
                </div>
                <div className="not-fixed-heading-status-item">
                  <ConditionIcon status={10} size="small" />
                  <span className="not-fixed-heading-status-text">{t("cc_customer_ok").message || "Customer OK"}</span>
                </div>
              </div>
            )}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="not-fixed-header">
          <Grid.Column width={hideStatusIcons ? 12 : 10}>{t("cc_item_name").message || "ITEM NAME"}</Grid.Column>

          <Grid.Column width={2}>{t("cc_photo").message || "PHOTO"}</Grid.Column>
          <Grid.Column width={2}>{settings.include_vat ? t("cc_vat_price").message || "Incl. VAT" : t("cc_no_vat_price").message || "Excl. VAT"}</Grid.Column>
          {!hideStatusIcons && (
            <Grid.Column width={1} textAlign="center">
              {t("cc_current_status").message || "CURRENT STATUS "}
            </Grid.Column>
          )}
        </Grid.Row>

        {this.renderInterventions(interventions)}
        {this.renderNotFixedItems(notFixedItems)}
      </Grid>
    );
  }
}

const TranslatedNotFixedItems = withTranslation()(NotFixedItems);

TranslatedNotFixedItems.filterNotFixedItems = results => {
  return results.filter(r => {
    if (TYRE_POSITION.IS_TYRE(r.tyre_position) && r.tyre_replacements.length > 0) {
      if (!r.tyre_replacements.some(tr => tr.mechanic_fixed)) {
        if (r.tyre_replacements.length === 1) r.price = r.tyre_replacements[0].price;
        else r.price = -1;

        r.customer_approved = r.tyre_replacements.some(tr => tr.customer_answer);
        return true;
      } else {
        if (r.question_status !== QUESTION_RESULT_STATUS.ADVISED || r.question_status !== QUESTION_RESULT_STATUS.NECESSARY || r.mechanic_fixed) return false;

        return true;
      }
    } else {
      return (r.question_status === QUESTION_RESULT_STATUS.ADVISED || r.question_status === QUESTION_RESULT_STATUS.NECESSARY) && !r.mechanic_fixed;
    }
  });
};

export default TranslatedNotFixedItems;
